export const getBasePath = (): string => {
  const stage = process.env.REACT_APP_STAGE;

  if (stage === "local") {
    return "http://localhost";
  }
  return window.location.origin;
};
